import { useMutation, useQuery } from "convex/react"
import { api } from "../../../../convex/_generated/api"

/** Profile + ensureProfile for the employer work-email OTP route. */
export function useEmployerVerifyProfile() {
  const profile = useQuery(api.profiles.me)
  const ensureProfile = useMutation(api.profiles.ensureProfile)
  return { profile, ensureProfile }
}
